import { TurboMount } from "turbo-mount";
import { registerComponent } from "turbo-mount/react";

const turboMount = new TurboMount();

// Dynamic import: VideoPanelWrapper is a .jsx file that gets React Refresh
// injected by @vitejs/plugin-react in dev mode. Static import would kill
// the entire JS bundle if the preamble check fails. Dynamic import isolates
// the failure to just the video component.
import("./components/video/VideoPanelWrapper").then((mod) => {
  registerComponent(turboMount, "VideoPanel", mod.default);
});
